import { atom } from 'jotai';
export const $RootLoaderLoaded = atom(false);
$RootLoaderLoaded.debugLabel = '$RootLoaderLoaded';
